// extracted by mini-css-extract-plugin
export default {"courses":"styles_courses__eC82v","__in":"styles___in__99SoE","title":"styles_title__PhpfB","sub_title":"styles_sub_title__Ew8y5","list":"styles_list__SvAzK"};